<template>
	<div class="report-container">
		<div :class="['ui', 'inverted', { active: isLoading }, 'dimmer']">
			<div class="ui text loader"></div>
		</div>
		<div class="ui padded grid" style="padding-bottom: 1rem;">
			<div class="row">
				<div class="eight wide column">
					<div class="ui form">
						<div class="inline fields">
							<div class="field">
								<button class="ui button basic icon small" @click="goBack()">
									<i class="arrow left icon"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="right aligned eight wide column">
					<notifications-button></notifications-button>
					<a
						href="mailto:suportegig@neocom.info"
						class="ui icon basic button"
						data-tooltip="suportegig@neocom.info"
						data-position="left center"
					>
						<i class="mail icon"></i>
					</a>
				</div>
			</div>
		</div>
		<component :is="currentView"></component>
	</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import NotificationsButton from '@/components/notifications-button/notifications-button';

  import {i18nMixin} from '@/modules/neodash/mixins';

  import {GET_LOADING} from '@/store/types';

  export default {
    data() {
      return {
        reportName: this.$route.params.reportName,
        subReportName: this.$route.params.subReportName
      };
    },

    computed: {
      ...mapGetters({
        isLoading: GET_LOADING
      }),

      currentView() {
        return `${this.reportName}-upload`;
      }
    },

    mixins: [i18nMixin],

    methods: {
      goBack() {
        window.history.back();
      }
    },

    components: {
      NotificationsButton,
    }
  };
</script>

<style lang="scss" scoped>
	.ui.basic.button,
	.ui.basic.buttons {
		background-color: #ffffff !important;
		box-shadow: inset 0 1px 0 hsla(0, 0%, 100%, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
		border: 1px solid #ccc !important;
	}
</style>
